import React, { forwardRef, useRef, useState } from "react";

/** Identical Enter/Escape/blur behavior on SVG nodes, concepts and relationship labels. */
const InlineMapLabelInput = forwardRef(function InlineMapLabelInput(
  {
    initialValue,
    onCommit,
    className = "h-full w-full rounded-xl border-2 border-[#315f90] bg-white px-3 text-center text-sm font-semibold text-slate-900 shadow-xl outline-none",
    ...props
  },
  forwardedRef,
) {
  const inputRef = useRef(null),
    committing = useRef(false);
  const [busy, setBusy] = useState(false);
  const commit = async (save, value) => {
    if (committing.current) return;
    committing.current = true;
    setBusy(true);
    try {
      if ((await onCommit(value, save)) === false) {
        committing.current = false;
        inputRef.current?.focus();
      }
    } catch {
      // The controller reports the error. Keep the user's draft available for retry.
      committing.current = false;
      inputRef.current?.focus();
    } finally {
      setBusy(false);
    }
  };
  return (
    <input
      {...props}
      ref={(element) => {
        inputRef.current = element;
        if (typeof forwardedRef === "function") forwardedRef(element);
        else if (forwardedRef) forwardedRef.current = element;
      }}
      defaultValue={initialValue}
      maxLength={500}
      readOnly={busy}
      aria-busy={busy || undefined}
      className={className}
      onBlur={(event) => {
        void commit(true, event.currentTarget.value);
      }}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === "Enter" || event.key === "Escape") {
          event.preventDefault();
          void commit(event.key === "Enter", event.currentTarget.value);
        }
      }}
    />
  );
});
export default InlineMapLabelInput;
